import PublicIcon from "@mui/icons-material/Public";
import { IconButton, IconButtonProps } from "@mui/material";

export function OpenGoogleMapsIconButton({ onClick, disabled, ...otherProps }: IconButtonProps) {
  return (
    <IconButton {...otherProps} onClick={onClick} disabled={disabled}>
      <PublicIcon />
    </IconButton>
  );
}
